// extracted by mini-css-extract-plugin
export default {"control":"Product_control__QniCy","richText":"Product_richText__Usidq"};